module.exports = __webpack_public_path__ + "static/media/icon_142.129995d1.svg";